module.exports = "{{ timeLeft$ | async | timeLeft:format }}<ng-content></ng-content>";